import axios from 'axios';
import { FETCH_SHOP_BY_BRAND_FAILURE, FETCH_SHOP_BY_BRAND_REQUEST, FETCH_SHOP_BY_BRAND_SUCCESS } from '../../constants/shopByBrand/shopByBrand';
import { BASE_URL } from '../../constants/base.constant';

export const fetchRequest = () => {
  return {
    type: FETCH_SHOP_BY_BRAND_REQUEST,
  };
};

export const fetchSuccess = (data: any) => {
  return {
    type: FETCH_SHOP_BY_BRAND_SUCCESS,
    payload: data,
  };
};

export const fetchFailure = (error: any) => {
  return {
    type: FETCH_SHOP_BY_BRAND_FAILURE,
    payload: error,
  };
};

export const fetchShopByBrandData = () => {
  return async (dispatch: any) => {
    dispatch(fetchRequest());
    try {
      const { data } = await axios.get(`${BASE_URL}/customers/shop-by-brands`);
      dispatch(fetchSuccess(data.data));
    } catch (error: any) {
      dispatch(fetchFailure(error.message));
    }
  };
};
